import dragon from './dragon_invite/ru.json';
import exchangeShop from './exchange_shop/ru.json';

export default {
    ...dragon,
    ...exchangeShop
};
